<app-elevation-section [title]="titleForecastOrders">
    <div class="grid-wrapper-forecast-detail-orders"  [ngClass]="{'disabled' : isAdding}">
        <div class="grid-wrapper-forecast-detail-orders-row-1">
            <app-date-selector 
                            (changeDate)="dateChangedForecastOrders($event)" 
                            [selectedDate]="selectedDateForecastOrders"
                            [setTabsDateRangeSelectedIndexInput]="3"
                            [showDay]="false" 
                            [showWeek]="false" 
                            [showMonth]="false"
                            [showDateTabs]="false"
                            [hasTodayButton]="false"></app-date-selector>
        </div>
        <div class="grid-wrapper-forecast-detail-orders-row-2">
                <dx-data-grid #dataGridForecastOrders style="margin-top: -60px;"
                    [dataSource]="dataSourceForecastOrders"
                    [columns]="columnsForecastOrders"
                    [rowAlternationEnabled]="true"
                    [columnAutoWidth]="true"
                    (onRowInserting)="onRowInsertingForecastOrders($event)"
                    (onRowUpdating)="onRowUpdatingForecastOrders($event)"
                    (onRowRemoving)="onRowRemovingForecastOrders($event)"
                    (onInitNewRow)="onInitNewRowForecastOrders($event)">
                    <dxo-paging [pageSize]="15"></dxo-paging>
                    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-editing mode="row"
                                [allowUpdating]="true"
                                [allowDeleting]="true"
                                [allowAdding]="true"
                                [useIcons]="true">
                    </dxo-editing>
                    <dxo-summary [calculateCustomSummary]="calculateSummary">
                        <dxi-total-item
                            name="customSumJan"
                            summaryType="custom"
                            displayFormat="{0}"
                            showInColumn="Jan">
                        </dxi-total-item>
                        <dxi-total-item
                            name="customSumFeb"
                            summaryType="custom"
                            displayFormat="{0}"
                            showInColumn="Feb">
                        </dxi-total-item>
                        <dxi-total-item
                            name="customSumMar"
                            displayFormat="{0}"
                            summaryType="custom"
                            showInColumn="Mar">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Apr"
                        name="customSumApr"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="May"
                        name="customSumMay"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="June"
                        name="customSumJune"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="July"
                        name="customSumJuly"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Aug"
                        name="customSumAug"
                        displayFormat="{0}"
                            showInColumn="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Sep"
                        name="customSumSep"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Oct"
                        name="customSumOct"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Nov"
                        name="customSumNov"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                        <dxi-total-item
                        showInColumn="Dec"
                        name="customSumDec"
                        displayFormat="{0}"
                            summaryType="custom">
                        </dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
        </div>
    </div>
</app-elevation-section>
<br>
<app-elevation-section [title]="titleHistoryOrders">
    <div class="grid-wrapper-forecast-detail-orders" [ngClass]="{'disabled' : isAdding}">
        <div class="grid-wrapper-forecast-detail-orders-row-1">
            <app-date-selector 
                            (changeDate)="dateChangedHistoryOrders($event)" 
                            [selectedDate]="selectedDateHistoryOrders"
                            [setTabsDateRangeSelectedIndexInput]="3"
                            [showDay]="false" 
                            [showWeek]="false" 
                            [showMonth]="false"
                            [showDateTabs]="false"
                            [hasTodayButton]="false"></app-date-selector>
        </div>
        <div class="grid-wrapper-forecast-detail-orders-row-2">
                <dx-data-grid #datagriddx style="margin-top: -60px;"
                    [dataSource]="dataSourceHistoryOrders"
                    [columns]="columnsHistoryOrders"
                    [rowAlternationEnabled]="true"
                    [columnAutoWidth]="true">
                    <dxo-paging [pageSize]="15"></dxo-paging>
                    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <div *dxTemplate="let data of 'cellTemplateType'">
                      <span>{{data.data.Type == "Count" ? titleCount : titleSum}}</span>
                    </div>
                </dx-data-grid>
        </div>
    </div>
</app-elevation-section>